<script>
import ButtonBase from '@/components/helper/add/button-base.vue'
import PopupBase from '@/components/helper/add/popup-base.vue'
import http from '@/plugins/http'
import apiRoute from '@/router/api-routes'

export default {
  name: 'confirm-delete-admin',
  components: {
    PopupBase,
    ButtonBase
  },
  props: {
    adminId: Number
  },
  data () {
    return {
      loader: false,
      error: false,
      errorMessage: ''
    }
  },
  computed: {
    isSelf () {
      const me = this.$store.getters.userInfos || {}
      return me.id && Number(me.id) === Number(this.adminId)
    }
  },
  methods: {
    deleteArticle () { // ARCHIVE ONE ADMIN
      if (this.isSelf) {
        this.error = true
        this.errorMessage = 'Vous ne pouvez pas archiver votre propre compte administrateur.'
        return
      }
      this.loader = true
      this.error = false
      this.errorMessage = ''
      http.patch(apiRoute.baseURL + apiRoute.archiveAdmin, {
        userId: this.adminId
      }, {
        headers: {
          Authorization: `Bearer ${this.$store.getters.loginToken}`
        }
      })
        .then(response => {
          console.log(response)
          this.$emit('openSuccessDelete', true)
        }).catch(error => {
          console.log(error)
          this.error = true
          this.errorMessage = (error.data && error.data.message)
            ? error.data.message
            : 'Une erreur est survenue lors de l\'archivage.'
        }).finally(() => {
          this.loader = false
        })
    },
    goBack () {
      this.$emit('closeDelete', false)
    }
  }
}
</script>

<template>
  <div class="confirm-delete-admin">
    <popup-base @clickOutside="goBack">
      <div class="begin bg-white m-auto w-1/2 rounded-lg p-8">
        <div class="header flex items-center justify-between">
          <div class="header-title font-medium text-2xl text-black">Archiver administrateur</div>
          <div class="delete-icon cursor-pointer" @click="goBack">
            <svg-icon name="ic_close" original class="w-4 h-4"/>
          </div>
        </div><br>
        <div class="body mt-6">
          <div class="title">Voulez-vous vraiment archiver cet administrateur ?</div><br>
          <div v-if="error" class="text-red-600 text-center mt-2">{{ errorMessage }}</div>
          <div class="delete-button flex items-center justify-end mt-4">
            <div class="deletion">
              <button-base
                label="Archiver"
                :is-loading="loader"
                :disabled="isSelf"
                @click.native="deleteArticle"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/style/sass/variables";
.deletion::v-deep {
  .button-base {
    .page-button-real {
      background-color: #C43A2B !important;
    }
  }
}
</style>
